/* Kudzu Seeds Trading form honeypot (kudzuseeds.com). Adapted June 2026; checks extended 10 Oct 2026 (KZU-30).
   Injects a hidden trap field (contact[hp_url]) into Shopify customer (newsletter) and contact forms, and
   silently drops the submit when any trap field on the form has been filled: contact[hp_url], website,
   website_url, contact[website], contact[website_url]. A person never sees or fills these fields, so normal
   submits are not affected; nothing is shown to the visitor when a bot fills one. */
(function () {
  var TRAPS = 'input[name="contact[hp_url]"], input[name="website"], input[name="website_url"], input[name="contact[website]"], input[name="contact[website_url]"]';
  function isTarget(form) {
    var a = (form.getAttribute('action') || '');
    return (
      a.indexOf('/contact') !== -1 ||
      form.id === 'contactForm' ||
      !!form.querySelector('input[name="contact[email]"]')
    );
  }

  function addHoneypot(form) {
    if (form.getAttribute('data-hp-ready')) return;
    if (!isTarget(form)) return;
    /* Skip if a honeypot already exists on this form */
    if (form.querySelector(TRAPS)) {
      form.setAttribute('data-hp-ready', '1');
      return;
    }
    var wrap = document.createElement('div');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'position:absolute!important;left:-9999px!important;top:auto!important;width:1px;height:1px;overflow:hidden;';
    var label = document.createElement('label');
    label.setAttribute('for', 'cs-hp-url');
    label.textContent = 'Leave this field empty';
    var input = document.createElement('input');
    input.type = 'text';
    input.id = 'cs-hp-url';
    input.name = 'contact[hp_url]';
    input.tabIndex = -1;
    input.setAttribute('autocomplete', 'off');
    input.value = '';
    wrap.appendChild(label);
    wrap.appendChild(input);
    form.appendChild(wrap);
    form.setAttribute('data-hp-ready', '1');
  }

  function scan() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) addHoneypot(forms[i]);
  }

  function trapped(form) {
    var hps = form.querySelectorAll(TRAPS);
    for (var i = 0; i < hps.length; i++) {
      if (hps[i].value && String(hps[i].value).trim() !== '') return true;
    }
    return false;
  }

  /* Capture-phase guard: silently drop the submit if any trap is filled (runs before other handlers) */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (trapped(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Re-scan for dynamically injected forms (e.g. modal/newsletter popups) */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { scan(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
